/* Fills an image slot with the resolved media asset. A real uploaded
   image (Storage URL) renders as an <img> with alt text for
   accessibility; the legacy gradient placeholders render as a
   background. The slot's positioning/overlays are unchanged. */
import { useContent } from '../content/ContentContext.jsx'

export function MediaFill({ id }) {
  const { media } = useContent()
  const m = media.find((x) => x.id === id)

  if (m && m.url) {
    return (
      <>
        <img className="grad-img" src={m.url} alt={m.alt || ''} loading="lazy" />
        <div className="ph"></div>
      </>
    )
  }

  const css = m ? m.css : 'linear-gradient(145deg,#26221d,#131210)'
  return (
    <>
      <div className="grad-img" style={{ background: css }}></div>
      <div className="ph"></div>
    </>
  )
}
